import { Box, ButtonBase, IconButton, useTheme } from "@mui/material";
import { useEffect, useState } from 'react';
// import { ColorModeContext, tokens } from '../../../theme';
import MenuIcon from '@mui/icons-material/Menu';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useTopbar } from "../../../contexts/TopbarProvider";
import { toggleMenu } from '../../../newapi/global/settingsSlice';
import { useGetMonitorsMutation, useGetSpecificMonitorStatusQuery } from "../../../newapi/uptimebot/uptimeRobotSlice";
import { selectUser } from "../../../newapi/user/authentication/authSlice";
import { tokens } from '../../../theme';
import { GeneralSearch } from "../../theme/Search/GeneralSearch";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import TopbarActionModal from "../Modals/ActionModal/MTopbarAction";
import MSelectWorkspaces from "../Modals/MSelectWorkspaces";
import { ENV_TYPES } from '../Sidebar';
import WarehousePicker from '../WarehousePicker';
import LanguagePicker from './components/LanguagePicker';
import TopbarNotifications from './views/TopbarNotifications';
import ProgressCenter from './ProgressCenter/ProgressCenter';
import MeldingSlot from './components/MeldingSlot';
// import { MenuStateContext } from '../../../contexts/MenuState';



const Topbar = () => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const { extraComponent,title } = useTopbar(); 

    const {data: monitorData} = useGetSpecificMonitorStatusQuery(undefined, {
         pollingInterval: process.env.NODE_ENV !== "development" ? (300000) : false,
    });

    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const onOnline = () => setIsOnline(true);
        const onOffline = () => setIsOnline(false);

        window.addEventListener("online", onOnline);
        window.addEventListener("offline", onOffline);

        return () => {
            window.removeEventListener("online", onOnline);
            window.removeEventListener("offline", onOffline);
        };
    }, []);

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

    const handleFilterPopoverClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterPopoverClose = () => {
        setFilterAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const changeMenuState = () => {
        dispatch(toggleMenu());
    }
    
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const workSpace = useSelector((state) => state.settings.workSpace);
    const activeWarehouse = useSelector((state) => state.warehouse);
    const showWarehousePicker = !(activeWarehouse.activeId > 0 && activeWarehouse.activeName === '');

    const [open, setOpen] = useState(false);
    const workSpaceModal = {
        open: open,
        setOpen: setOpen
    }
    const user = useSelector(selectUser);

    // A string title gets the standard Subheading; a page that passes its own node (title plus a filter,
    // for instance) renders it as-is so it isn't nested inside a heading.
    let titleNode = title;
    if (typeof title === "string") {
        titleNode = <Subheading>{title}</Subheading>;
    }

    return (
        <Box 
            className="topbar" 
            display="flex" 
            justifyContent="space-between" 
            paddingX={4} paddingY={2}
            sx={{
                background:colors.bg["tertiary"],
                "@media screen and (max-width: 47.9375em)" : {
                    paddingX:2,
                    paddingRight:isRelation ? 3 :0,
                },
                "@media screen and (max-width: 1024px)" : {
                    gap:1,
                    px:1,
                    paddingRight:isRelation ? 1 :0,

                }
            }}    
        >

            <Box
                sx={{
                    display:"flex",
                    alignItems:"center",
                    gap:2,
                    "@media screen and (max-width: 1024px)" : {
                        gap:1,
                    }
                }}
            >
                <IconButton type="button" onClick={changeMenuState} sx={{p:1}}>
                    <MenuIcon/>
                </IconButton>
                {title !== null && titleNode}
                <MeldingSlot />
            </Box>

            {/* Icons */}
            <Box 
                display="flex"
                gap={2}
                sx={{
                    alignItems:'center',
                    "@media screen and (max-width: 47.9375em)" : {
                        alignItems:"center",
                    },
                    "@media screen and (max-width: 1024px)" : {
                        gap:1,
                    }
                }}
            >
                {!isOnline ? 
                    <Box
                        sx={{
                            minWidth:700,
                            textAlign:'center',
                            px:2,
                            height:32,
                            lineHeight:"32px",
                            background:colors.red[400],
                            borderRadius:4,
                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontSize:14,
                            fontWeight:500,
                            fontFamily:"Roboto, sans-serif",

                            "@media screen and (max-width: 47.9375em)" :{
                                minWidth:0,
                                borderTopRightRadius:0,
                                borderBottomRightRadius:0,
                            }
                        }}
                    >
                        {t("you_are_offline")}
                    </Box> 
                :
                monitorData?.isDown ? 
                    <Box
                        sx={{
                            minWidth:300,
                            textAlign:'center',
                            px:2,
                            height:32,
                            lineHeight:"32px",
                            background:colors.red[400],
                            borderRadius:4,
                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontSize:14,
                            fontWeight:500,
                            fontFamily:"Roboto, sans-serif",

                            "@media screen and (max-width: 47.9375em)" :{
                                minWidth:0,
                                borderTopRightRadius:0,
                                borderBottomRightRadius:0,
                            }
                        }}
                    >
                        {t("system_down")}
                    </Box> 
                
                :
                <>
                    {extraComponent !== null && extraComponent}
                    <GeneralSearch/>


                    {selectedEnvironmentType === ENV_TYPES[100] && showWarehousePicker &&
                        <WarehousePicker phone={false} />
                    }


                    <TopbarNotifications/>

                    <ProgressCenter />

                    <Box
                        sx={{
                            height:40,
                            borderRadius:5,

                            background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            px:0.5,
                            pl:0.5,
                            display:"flex",
                            alignItems:'center',
                            "@media screen and (max-width: 47.9375em)" : {
                                display:'none',
                            }
                        }}
                    >
                        {selectedEnvironmentType === ENV_TYPES[100] ?
                            <ButtonBase
                                onClick={() => {
                                    {selectedEnvironmentType === ENV_TYPES[100] &&
                                        workSpaceModal.setOpen(true)
                                    }
                                }}
                                sx={{
                                    height:32,
                                    display:"flex",
                                    alignItems:'center',
                                    borderRadius:5,
                                    pr:3,
                                    transition:"250ms",
                                    "&:hover" : {
                                        transition:"250ms",
                                        background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100]
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.blue[100]  : colors.primary[100],
                                        width:32,
                                        height:32,
                                        borderRadius:20,
                                        padding:0,
                                        minWidth:0,
                                        boxShadow:"none",
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:'center',
                                        transition:"250ms",
                                        color:theme.palette.mode === "dark" ? colors.blue[400]  : colors.primary[400],
                                    }}
                                >
                                    <PersonOutlinedIcon/>

                                </Box>
                                <Box
                                    sx={{
                                        ml:1,
                                        display:'flex',
                                        flexDirection:'column',
                                        maxWidth:140,
                                    }}
                                >

                                    <Text noBreak fontSize={12} bold>{user?.name}</Text>

                                    <Text fontSize={12} noBreak>
                                        {workSpace.id === -1 ? t(workSpace?.name) : workSpace?.name}
                                    </Text>
                                </Box>
                            </ButtonBase>
                        :
                            <Box
                                sx={{
                                    height:32,
                                    display:"flex",
                                    alignItems:'center',
                                    pl:0.5,
                                    borderRadius:5,
                                    pr:3,
                                }}
                            >
                                <Box
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.blue[100]  : colors.primary[100],
                                        width:32,
                                        height:32,
                                        borderRadius:20,
                                        padding:0,
                                        minWidth:0,
                                        boxShadow:"none",
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:'center',
                                        transition:"250ms",
                                        color:theme.palette.mode === "dark" ? colors.blue[400]  : colors.primary[400],
                                    }}
                                >
                                    <PersonOutlinedIcon/>
                                </Box>
                                <Box
                                    sx={{
                                        ml:1,
                                        display:'flex',
                                        flexDirection:'column',
                                        maxWidth:140,
                                    }}
                                >

                                    <Text noBreak fontSize={12} bold>{user?.name}</Text>
                                </Box>

                            </Box>
                        }
                        <Box sx={{mr:1}}>
                            <LanguagePicker/>
                        </Box>
                        <ButtonBase
                            onClick={handleFilterPopoverClick}
                            TouchRippleProps={{
                                style: {
                                    color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)'
                                }
                            }} // Directly styling the ripple here
                            variant='contained'
                            sx={{
                                background:theme.palette.mode === "dark" ? colors.nav["linkBg"]  : colors.grey[100],
                                width:32,
                                height:32,
                                borderRadius:20,
                                padding:0,
                                minWidth:0,
                                boxShadow:"none",
                                display:"flex",
                                alignItems:"center",
                                transition:"250ms",
                                color: colors.txt["primary"],
                                opacity:1,
                                "&:hover" : {
                                    transition:"250ms",
                                    background:theme.palette.mode === "dark" ? colors.grey[300] : "white",
                                    boxShadow:"0px 2px 8px rgba(49, 65, 95, 0.25)"
                                },
                                "@media screen and (max-width: 47.9375em)" : {
                                    width:32,
                                    height:32,
                                    borderRadius:16
                                }
                            }}
                        >
                            <SettingsOutlinedIcon />

                        </ButtonBase>

                    </Box>
                    <ButtonBase
                        onClick={handleFilterPopoverClick}
                        TouchRippleProps={{ 
                            style: { 
                                color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)' 
                            } 
                        }} // Directly styling the ripple here
                        variant='contained'
                        sx={{
                            background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                            width:32,
                            height:32,
                            borderRadius:20,
                            padding:0,
                            minWidth:0,
                            boxShadow:"none",
                            display:"none",
                            alignItems:"center",
                            transition:"250ms",
                            color: colors.txt["primary"],
                            opacity:1,
                            "&:hover" : {
                                transition:"250ms",
                                background:theme.palette.mode === "dark" ? colors.grey[300] : "white",
                                boxShadow:"0px 2px 8px rgba(49, 65, 95, 0.25)"
                            },
                            "@media screen and (max-width: 47.9375em)" : {
                                display:"flex",
                                width:32,
                                height:32,
                                borderRadius:16
                            }
                        }}
                    >
                        <SettingsOutlinedIcon />

                    </ButtonBase>

                    <TopbarActionModal
                        id={filterPopoverId}
                        open={filterPopoverOpen}
                        anchorEl={filterAnchorEl}
                        onClose={handleFilterPopoverClose}
                    >

                    </TopbarActionModal>


                    {selectedEnvironmentType === ENV_TYPES[100] && showWarehousePicker &&
                        <WarehousePicker desktop={false} />
                    }

                    {selectedEnvironmentType === ENV_TYPES[100] &&
                        <MSelectWorkspaces
                            open={workSpaceModal.open} 
                            handleClose={() => workSpaceModal.setOpen(false)}
                        />
                    }
                </>
                }
            </Box>
            
        </Box>
    );
};

export default Topbar;


// <ButtonGroup version={2} isSidepanel>
// {orderData && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS, general_states.CANCELLED].includes(orderData?.state) &&
//     (orderData.amountOfProducts > 1 && hasModifyPrivilege) &&
//     <Shbutton
//         block
//         onClick={() => addModal.setOpen(true)}
//         className={"group-btn"}
//         color={"primaryGrey"}
//         variant="contained"
//     >
//         {t('split_order')}
//         </Shbutton>
// }
// {hasModifyPrivilege &&
// <Shbutton
//     block
//     onClick={() => confirmDuplicateModal.setOpen(true)}
//     className={"group-btn"}
//     color={"primary"}
//     variant="contained"
//     endIcon={<ContentCopyIcon />}
// >
//     {t('duplicate_order')}
// </Shbutton>
// }
// {hasCreateReturnPermission && orderData?.state === general_states.SHIPPED && 
//     <Shbutton
//         block
//         onClick={() => returnModal.setOpen(true)}
//         className={"group-btn"}
//         color={"primaryGrey"}
//         variant="contained"
//     >
//         {t('create_return')}
//     </Shbutton>
// }
// {hasCreateReturnPermission && orderData?.state !== general_states.CANCELLED && orderData?.state !== general_states.SHIPPED && 
// <Shbutton
//     block
//     onClick={() => shipmentModal.setOpen(true)}
//     className={"group-btn"}
//     color={"primary"}
//     variant="contained"
// >
//     {t('create_shipment')}
// </Shbutton>
// }
// </ButtonGroup>